import React from 'react';

import ExistingMemberSearch from './ExistingMemberSearch';

const ExistingMemberSearchOther = () => (
  <ExistingMemberSearch />
);

export default ExistingMemberSearchOther;